<template>
    <div class="max" data-view="start.irco.v12019">
        <v-layout fill-height justify-center align-center>
            <v-window vertical v-model="co" class="max" :class="loadSection(0) ? 'loaded' : ''">
                <v-window-item class="max content-holder" :class="load ? 'active' : ''">
                    <div data-view="strat.id-get-started.v12019" class="max ">
                        <v-layout fill-height justify-center align-center >
                            <v-flex xs12 md8 class="text-center content-item" >
                                <span class="t40 font-weight-light">We are a 
                                <span class="secondary--text">product company</span>
                                aimed at
                                <span class="accent--text">impactful </span>
                                <span class="amber--text text--darken-2">creation</span>
                                within a fast moving environment 
                                <span class="tertiary--text">intelligent</span>
                                sofware. 
                                </span>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-window-item>
                <v-window-item class="max">
                    <div data-view="strat.id-get-started.v12019" class="max">
                        <v-layout fill-height justify-center align-center >
                            <v-flex xs12 md3 my-12 class="text-center">
                                <v-card>
                                    <v-card-title class=" justify-center">
                                        <v-avatar size="180" color="bgGrey">
                                            <v-img cover src="https://cdn.dribbble.com/users/746919/screenshots/2625503/dd.png"></v-img>
                                        </v-avatar>
                                    </v-card-title>
                                    <v-card-text class="py-0 t10 grey--text text-uppercase">Founder</v-card-text>
                                    <v-card-text class="py-0 t22 font-weight-black black--text">Josh Olson</v-card-text>
                                    <v-divider class="my-4 mx-6"></v-divider>
                                    <v-card-text class="pt-0 pb-8">
                                        Some explanation about what Josh has done and brings to the table as far as Dolo labs is concerned.
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 md3 my-12 px-2 class="text-center">
                                <v-card>
                                    <v-card-title class=" justify-center">
                                        <v-avatar size="180" color="bgGrey">
                                            <v-img cover src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQbJjzXPKrsACNNMtY4ojeZdcO_EgrkXI8SLqTzcjRWKM4aAZu&s"></v-img>
                                        </v-avatar>
                                    </v-card-title>
                                    <v-card-text class="py-0 t10 grey--text text-uppercase">DevOps</v-card-text>
                                    <v-card-text class="py-0 t22 font-weight-black black--text">Bevin Thomas</v-card-text>
                                    <v-divider class="my-4 mx-6"></v-divider>
                                    <v-card-text class="pt-0 pb-8">
                                        Some explanation about what Bevin has done and brings to the table as far as Dolo labs is concerned.
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 md3 my-12 class="text-center">
                                <v-card>
                                    <v-card-title class=" justify-center">
                                        <v-avatar size="180" color="bgGrey">
                                            <v-img cover src="https://www.link-of-the-day.com/wp-content/uploads/2019/04/190411_Aaron-Martinez_13-1024x1024.jpg"></v-img>
                                        </v-avatar>
                                    </v-card-title>
                                    <v-card-text class="py-0 t10 grey--text text-uppercase">ProdOps</v-card-text>
                                    <v-card-text class="py-0 t22 font-weight-black black--text">Lauren Reed</v-card-text>
                                    <v-divider class="my-4 mx-6"></v-divider>
                                    <v-card-text class="pt-0 pb-8">
                                        Some explanation about what Lauren has done and brings to the table as far as Dolo labs is concerned.
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-window-item>
                <v-window-item class="max">
                    <div data-view="strat.id-get-started.v12019" class="max">
                        <v-layout fill-height justify-center align-center>
                            <v-flex xs12 md8 my-12 class="text-center" style="z-index: 1">
                                <span class="t40 font-weight-light">Our 
                                <span class="secondary--text">mission</span>
                                is to create
                                <span class="accent--text">impactful </span>
                                <span class="amber--text text--darken-2">performance management</span>
                                through simple, beautiful and 
                                <span class="tertiary--text">intelligent</span>
                                sofware. 
                                </span>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-window-item>
            </v-window>
        </v-layout>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        co: Number,
        coLength: Number,
    },
    data: () => {
        return {
            load: false
        }
    },
    methods: {
        loadSection(i){
            if(i == this.co){
                setTimeout(()=>{
                    this.load = true
                },500);
            } else {
                this.load = false
            }
        },

    }
}
</script>

<style lang="scss">
    .content-holder {
        .content-item {
            margin-top: 100px;
            opacity: 0;
            visibility: hidden;
            transition: all .34s;
        }
        &.active {
            .content-item {
                margin-top: 0;
                opacity: 1;
                visibility: visible;
            }
            
            
        }
    }
</style>